export default __webpack_public_path__ + "3ede6fb18ca5e48e4d1fc4da81dcec09.png";